import React, { Component } from "react";
import LoadingScreen from "../../includes/LoadingScreen";
import UserController from "../../controller/UserController";
import APIController from "../../controller/APIController";
import { faArrowRight, faDiagramProject, faFileWord, faCalendar } from "@fortawesome/free-solid-svg-icons";
import PageContent from "../../includes/PageContent";
import './CoursesListPageForTrainee.css';
import CenteredMessage from "../../includes/CenteredMessage";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Col, Container, Row } from "react-bootstrap";
import PradleAccordion from "../../components/PradleAccordion";
import DateTimeUtil from "../../util/DateTimeUtil";
import TopicKachel from "../../components/TopicKachel";
import he from "he";
import BuildingRoomTable from '../../components/tables/BuildingRoomTable';
import CourseTimespanBlock from '../../components/CourseTimespanBlock';


import { Badge } from "react-bootstrap";
import {
    faUserTie, faCheckCircle,
    faPlayCircle,
    faCalendarDay,
    faClock
} from "@fortawesome/free-solid-svg-icons";
class CoursesListPageForTrainee extends Component {


    constructor(props) {
        super(props);
        this.state = {
            isFetching: true,
            user: UserController.getUser(),
            traineeId: props.traineeId,
            worksheets: [],
            worksheetsGroupedByCourseId: {},
            worksheetsGroupedByTopicId: {},
            ltbView: props.lbtView
        }
        this.onWorksheetsUpdated = this.onWorksheetsUpdated.bind(this);
    }

    async componentDidMount() {
        try {
            let user = this.state.user;
            let traineeId = null;
            if (this.state.traineeId == undefined) {
                traineeId = UserController.getUser().id;
            }

            let courses = await APIController.getCoursesList();
            const now = new Date();

            courses.sort((a, b) => {
                const getStatus = (course) => {
                    const start = new Date(course.start);
                    const end = new Date(course.end);

                    const today = new Date();
                    today.setHours(0, 0, 0, 0);

                    const startDate = new Date(start);
                    startDate.setHours(0, 0, 0, 0);

                    const endDate = new Date(end);
                    endDate.setHours(0, 0, 0, 0);

                    // Kurs findet heute statt
                    if (startDate <= today && endDate >= today) {
                        return 0;
                    }

                    // Kommt noch
                    if (startDate > today) {
                        return 1;
                    }

                    // Ist vorbei
                    return 2;
                };

                const statusA = getStatus(a);
                const statusB = getStatus(b);

                // Erst nach Status
                if (statusA !== statusB) {
                    return statusA - statusB;
                }

                // Vergangene: neueste zuerst
                if (statusA === 2) {
                    return new Date(b.start) - new Date(a.start);
                }

                // Aktuell + kommende: älteste zuerst
                return new Date(a.start) - new Date(b.start);
            });
            let trainee = await APIController.getTraineeById(traineeId);

            this.setState({
                isFetching: false,
                courses: courses,
                trainee: trainee
            })
        } catch (e) {
            console.log(e);
            this.setState({
                isFetching: false,
                courses: [],
                trainee: null
            })
        }
    }

    onWorksheetsUpdated(updatedWorksheets) {
        let allworksheets = [];
        Object.keys(updatedWorksheets).map((course, sectionIndex) => {
            updatedWorksheets[course].map((w) => {
                allworksheets.push(w);
            });
        });
        this.setState({
            worksheets: allworksheets
        });
    }

    isCourseCompleted(endDateTime) {
        const end = new Date(endDateTime);
        const today = new Date();
        end.setHours(0, 0, 0, 0);
        today.setHours(0, 0, 0, 0);
        return end < today;
    }

    courseStatusText(startDateTime, endDateTime) {
        const start = new Date(startDateTime);
        const end = new Date(endDateTime);
        const today = new Date();

        start.setHours(0, 0, 0, 0);
        end.setHours(0, 0, 0, 0);
        today.setHours(0, 0, 0, 0);

        let text;
        let icon;
        let background;
        let color = '#333';

        if (end < today) {
            text = 'Kurs bereits abgeschlossen';
            icon = faCheckCircle;
            background = '#ccc';
        } else {
            const days = Math.round(
                (start.getTime() - today.getTime()) / (1000 * 60 * 60 * 24)
            );

            if (days < 0) {
                text = 'Kurs läuft aktuell';
                icon = faPlayCircle;
                background = 'yellow';
            } else if (days === 0) {
                text = 'Kurs startet heute';
                icon = faCalendarDay;
                background = '#ffc107';
            } else if (days === 1) {
                text = 'Kurs startet morgen';
                icon = faClock;
                background = '#ffe082';
            } else {
                text = `Kurs startet in ${days} Tagen`;
                icon = faClock;
                background = '#fff3cd';
            }
        }
        return (
            <span
                style={{
                    width: '100%',
                    textAlign: 'center',
                    background: background,
                    color: color,
                    padding: '0.5em'
                }}
            >
                <FontAwesomeIcon icon={icon} /> {text}
            </span>
        );
    }

    render() {

        if (this.state.isFetching) {
            return <LoadingScreen />;
        }

        if (!this.state.isFetching && this.state.courses.length === 0) {
            return (
                <PageContent>
                    <CenteredMessage>
                        <FontAwesomeIcon icon={faFileWord} />
                        Keine Kurse gefunden.
                    </CenteredMessage>
                </PageContent>
            )
        }

        return (
            <PageContent>
                <div className={"WorksheetsListPageForTrainee"} >
                    <>
                        <h2 className="px-3">{he.decode(this.state.trainee.firstname + " " + this.state.trainee.name)}</h2>
                    </>
                    <div className="px-3">
                        <Row>
                            {this.state.courses.map((course, idx) => {
                                const isPastCourse =
                                    this.isCourseCompleted(course.end);

                                const previousCourse =
                                    idx > 0
                                        ? this.state.courses[idx - 1]
                                        : null;
                                const isFirstPastCourse =
                                    isPastCourse &&
                                    (
                                        !previousCourse ||
                                        !this.isCourseCompleted(previousCourse.end)
                                    );
                                return (
                                    <>
                                    {isFirstPastCourse && (
                                        <Col xs={12}>
                                            <h2 className="mb-3 mt-4">
                                                Vergangene Kurse
                                            </h2>
                                        </Col>
                                    )}
                                    <Col xl={4} lg={6} md={12} xs={12}>
                                        <div className={"topicKachelOuter"}>
                                            <a href={UserController.getPortfolioCourseURL(this.state.trainee._id, course._id)} style={{ textDecoration: 'none' }}>
                                                <div className={"topicKachel"} style={{ background: 'var(--brand-primary)' }}>
                                                    <Row>
                                                        <Col xs={12} sm={12} style={{ display: 'flex', justifyContent: 'center', alignItems: 'start' }}>
                                                            {this.courseStatusText(course.start, course.end)}
                                                        </Col>
                                                        <Col xs={12} >
                                                            <div>
                                                                <h3 style={{marginBottom:0}}><span className={"topicId"} style={{ borderRadius: 0 }} >
                                                                    {course.name}
                                                                </span></h3>
                                                            </div>
                                                        </Col>
                                                        {(!this.isCourseCompleted(course.end)) &&
                                                        <>
                                                        <Col xs={12} sm={12} style={{ display: 'flex', justifyContent: 'center', alignItems: 'start' }}>
                                                            <div className={course.instructors.length>0?"pt-2":""} style={{background:'#f1f1f1', width:'100%', textAlign:'center'}}>
                                                                {course.instructors.map((instructor, i) => {
                                                                    return (<Badge style={{ marginRight: '0.2em', marginBottom: '0.2em' }}
                                                                        className={"instructorBadge"} bg="dark">
                                                                        <FontAwesomeIcon icon={faUserTie} /> {instructor.firstname} {instructor.name}
                                                                    </Badge>)
                                                                })}
                                                            </div>
                                                        </Col>
                                                               <Col xs={12}>
                                                            <div className={"topicKachelInner"}>
                                                                <div style={{ borderBottom: '1px solid #ccc', textAlign: 'center', background: '#f1f1f1', color: '#333' }}>
                                                                    <BuildingRoomTable
                                                                        items={course.schedules}
                                                                        compactView
                                                                        centerCompact
                                                                    />
                                                                </div>
                                                            </div>
                                                        </Col>
                                                        </>
                                                        }
                                                        <Col xs={12} sm={12} style={{ display: 'flex', justifyContent: 'center', alignItems: 'middle' }}>
                                                            <div className={"topicKachelInners"} className={""}>
                                                                <div className={"topicKachelInners"} style={{padding:'1em'}}>
                                                                    <CourseTimespanBlock courseStartDateTime={course.start} courseEndDateTime={course.end} />
                                                                </div>
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                </div>
                                            </a>
                                        </div>
                                    </Col>
                                    </>
                                );
                            })}
                        </Row>
                    </div>
                </div>
            </PageContent>

        )

    }
}

export default CoursesListPageForTrainee;